export const removeCaracteresEspeciais = (value: string): string => {
    return value
        .normalize("NFD") // separa letras dos acentos
        .replace(/[\u0300-\u036f]/g, ""); // remove os acentos
};

export const spaceToUnderscore = (value: string): string => {
    return value.trim().replace(/\s+/g, "_");
};